var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDeducaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 16.1071V23L11.3644 19.9303L6.02014 23V16.1071L11.3644 13.0374L16.7086 16.1071Z",
    fill: "#6473FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5535V6.51319L6.02013 3.06671V9.96066L6.01413 9.96364V16.104L6.02013 16.107V23L0 19.5535Z",
    fill: "#00C4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7287 6.51319V19.5535L16.7086 23V16.107L16.7146 16.104V9.96364L16.7086 9.96066V3.06671L22.7287 6.51319Z",
    fill: "#00C4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7186 9.96366L11.3644 6.89296L6.01013 9.96366L0 6.51718L11.3644 0L22.7287 6.51718L16.7186 9.96366Z",
    fill: "#6473FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02013 23L0 19.5535L6.02013 16.1071",
    fill: "#8C50E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDeducaIcon);
export default __webpack_public_path__ + "static/media/logo-deduca-icon.b244df9417f6933e9ec88c918e911438.svg";
export { ForwardRef as ReactComponent };